import { useEffect, useState } from 'react'
import Categories from './productList/Categories'
import Carousel from './basic/Carousel'
import ProductList from './productList/ProductList'
import { useDispatch, useSelector } from 'react-redux'
import useCategoryService from '../services/category'
import useBannerService from '../services/banners'
import { useLocation } from 'react-router-dom'
import { changeLanguage } from '../reducers/languageReducer'

const HomePage = () => {
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const withShop = useSelector((state) => state.lang.selectedLang !== 'de')
  const categoryService = useCategoryService()
  const bannerService = useBannerService()
  const selectedLang = useSelector((state) => state.lang.selectedLang)
  const [banners, setBanners] = useState([])
  console.log(banners)
  const [homeItems, setHomeItems] = useState({
    products: [],
    displayName: '',
  })
  const [discountedProducts, setDiscountedProducts] = useState({
    products: [],
    displayName: '',
  })
  const [allProducts, setAllProducts] = useState({
    categories: [],
    displayName: '',
  })
  useEffect(() => {
    console.log(pathname)
    if (pathname === '/de' || pathname === '/de/') {
      dispatch(changeLanguage('de'))
    } else if (
      pathname === '/en' ||
      pathname === '/en/' ||
      pathname === '/eng' ||
      pathname === '/eng/'
    ) {
      dispatch(changeLanguage('en'))
    }
  }, [pathname])
  useEffect(() => {
    categoryService.getCategory('home').then((p) => setHomeItems(p))
    categoryService
      .getDiscountedProducts()
      .then((p) => setDiscountedProducts(p))
    categoryService.getTopCategory().then((p) => setAllProducts(p))
    bannerService.get().then((response) => setBanners(response.data.banners))
  }, [])
  return (
    <div className="row wrap-reverse">
      <div
        className="column no-gap"
        style={{ flex: '2 1 370px' }}>
        <Carousel
          className="m-d"
          banners={banners}
        />
        {withShop && discountedProducts.products.length > 0 && (
          <div>
            <h1 className="big-title m-d">
              {discountedProducts.displayName[selectedLang]}
            </h1>
            <ProductList products={discountedProducts.products} />
          </div>
        )}
        {homeItems.categories &&
          homeItems.categories.map((c) => (
            <div key={c.id}>
              <h1 className="big-title m-d">{c.displayName[selectedLang]}</h1>
              <ProductList products={c.products} />
            </div>
          ))}
      </div>
      <div
        className="column"
        style={{ flex: '1 1 300px' }}>
        <Categories categories={allProducts.categories} />
      </div>
    </div>
  )
}

export default HomePage
